(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doodle-studs-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initCarousel(root){
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const viewport = root.querySelector('.ds-carousel__viewport');
    const slides = Array.from(root.querySelectorAll('.ds-carousel__slide'));
    const prevBtn = root.querySelector('.ds-carousel__btn--prev');
    const nextBtn = root.querySelector('.ds-carousel__btn--next');
    const dots = Array.from(root.querySelectorAll('.ds-carousel__dot'));

    const AUTOPLAY = root.dataset.autoplay === 'true';
    const LOOP = root.dataset.loop === 'true';
    const INTERVAL = parseInt(root.dataset.interval, 10) || 4000;

    let autoplayTimer = null;
    let activeIndex = 0;

    function setActive(i){
      activeIndex = i;
      dots.forEach((d, idx) => d.setAttribute('aria-selected', idx === i ? 'true' : 'false'));
    }

    function scrollToSlide(i){
      const slide = slides[i];
      if (!slide || !viewport) return;
      const target = slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
      viewport.scrollTo({ left: target, behavior: 'smooth' });
      setActive(i);
    }

    function next(){ const atEnd = activeIndex >= slides.length - 1; scrollToSlide(atEnd ? (LOOP ? 0 : activeIndex) : activeIndex + 1); }
    function prev(){ const atStart = activeIndex <= 0; scrollToSlide(atStart ? (LOOP ? slides.length - 1 : 0) : activeIndex - 1); }

    prevBtn && prevBtn.addEventListener('click', prev);
    nextBtn && nextBtn.addEventListener('click', next);
    dots.forEach((dot, i) => dot.addEventListener('click', () => scrollToSlide(i)));
    viewport && viewport.addEventListener('keydown', e => { if (e.key === 'ArrowRight') next(); if (e.key === 'ArrowLeft') prev(); });

    if ('IntersectionObserver' in window && slides.length){
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6){
            const idx = slides.indexOf(entry.target);
            if (idx !== -1) setActive(idx);
          }
        });
      }, { root: viewport, threshold: [0.6] });
      slides.forEach(slide => io.observe(slide));
    }

    function startAutoplay(){
      if (!AUTOPLAY || slides.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => {
        const atEnd = activeIndex === slides.length - 1;
        if (atEnd && !LOOP) { stopAutoplay(); return; }
        next();
      }, INTERVAL);
    }
    function stopAutoplay(){ if (autoplayTimer){ clearInterval(autoplayTimer); autoplayTimer = null; } }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    viewport && viewport.addEventListener('focusin', stopAutoplay);
    viewport && viewport.addEventListener('focusout', startAutoplay);

    setActive(0);
    startAutoplay();

    addEventListener('resize', () => scrollToSlide(activeIndex));
  }

  // Init on first load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ds-carousel').forEach(initCarousel);
  });

  // Re-init when sections are re-rendered in the editor
  document.addEventListener('shopify:section:load', e => {
    const root = e.target.querySelector('.ds-carousel');
    if (root) initCarousel(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
